<template>
  <div style="display: inline-block">
    <el-dialog :visible.sync="dialog" :close-on-click-modal="false" :title="title" class="dialog" @close="cancel">
      <el-form ref="form" :model="form" :rules="rules" size="small">
        <el-form-item label="Old password" prop="oldPass">
          <el-input v-model="form.oldPass" type="password" auto-complete="off"/>
        </el-form-item>
        <el-form-item label="New password" prop="newPass">
          <el-input v-model="form.newPass" type="password" auto-complete="off"/>
        </el-form-item>
        <el-form-item label="Confirm new password" prop="confirmPass">
          <el-input v-model="form.confirmPass" type="password" auto-complete="off"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" @click="doSubmit">Modify</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import { updatePass } from '@/api/user'
import request from '@/utils/request'

export default {
  data() {
    const confirmPass = (rule, value, callback) => {
      if (value) {
        if (this.form.newPass !== value) {
          callback(new Error('The two passwords are inconsistent'))
        } else {
          callback()
        }
      } else {
        callback(new Error('Please enter the password again'))
      }
    }
    return {
      tenantId:'',
      loading: false, dialog: false, title: 'Change Password', form: { oldPass: '', newPass: '', confirmPass: '' },
      rules: {
        oldPass: [
          { required: true, message: 'Please enter the old password', trigger: 'blur' }
        ],
        newPass: [
          { required: true, message: 'Please enter a new password', trigger: 'blur' },
          { min: 6, max: 20, message: '6 to 20 characters in length', trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, validator: confirmPass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
          this.tenantId = res.tenant.id
          this.projectColor = res.tenant.projectColor
          this.schoolname = res.tenant.tenantName
          this.schoolHname = res.tenant.tenantHName
          this.schoollogo = res.tenant.tenantHLogo
      })
    },
    cancel() {
      this.resetForm()
      this.getinfo();
    },
    doSubmit() {
      if(this.tenantId == 13){
        this.$notify({
          message:'You can not change your password',
          type:'error',
          duration: 1500
        })
      }else{
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true
            updatePass(this.form).then(res => {
              if(res.code == 501){
                this.$notify({
                  message: 'Failed to modify',
                  type: 'error',
                  duration: 1500
                })
                this.loading = false;
              }else{
                this.resetForm()
                this.$notify({
                  message: 'Password modification succeeded, please login again',
                  type: 'success',
                  duration: 1500
                })
                setTimeout(() => {
                  store.dispatch('LogOutT').then(() => {
                    this.reload() // 为了重新实例化vue-router对象 避免bug
                    this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
                  })
                }, 1500)
                this.loading = false;
              }
            }).catch(err => {
              this.loading = false;
              console.log(err.response.data.message)
            })
          } else {
            return false
          }
        })
      }
    },
    resetForm() {
      this.dialog = false
      this.$refs['form'].resetFields()
      this.form = { oldPass: '', newPass: '', confirmPass: '' }
    }
  }
}
</script>

<style scoped>
  .el-form-item{
    border-bottom: none;
  }

  .dialog /deep/ .el-dialog{
    margin-top: 0 !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    padding: 12px 14px 14px 14px;
    border-radius: 4px;
  }
  .dialog /deep/ .el-dialog__header{
    padding: 0;
    text-align: center;
    margin-bottom: 12px;
  }
  .dialog /deep/ .el-dialog__header .el-dialog__headerbtn{
    height: 14px;
    float: right;
    top: 15px;
    right: 14px;
  }
  .dialog /deep/ .el-dialog__header .el-dialog__headerbtn .el-icon-close{
    float: left;
    width: 14px;
    height: 14px;
    background: url(../../../../assets/images/newimg/close.png) no-repeat;
  }
  .dialog /deep/ .el-dialog__body{
    padding: 0;
  }
  .dialog /deep/ .el-dialog__body .el-form-item__label{
    line-height: unset;
    margin-bottom: 7px;
  }
  .dialog /deep/ .el-dialog__body .el-input--small{
    font-size:14px;
    width: 100% !important;
  }
  .dialog /deep/ .el-input--small .el-input__inner{
    border-radius: 2px;
  }
  .dialog /deep/ .el-dialog__footer{
    padding: 0;
    text-align: center;
  }
  .dialog /deep/ .el-dialog__footer .el-button--default{
    font-size: 14px;
    padding: 8px 30px;
    background-color: #F38F38;
    color: #fff;
    border-color: #F38F38;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/center/updatePassEn.vue